// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useEffect, useState } from 'react';
import { HtmlScroll } from './HtmlScroll';
export function useScrollable(ref, isActive, axis = 'xy', events = null) {
    const [viewport, setViewport] = useState(null);
    useEffect(() => {
        var _a;
        if (!isActive || !ref.current) {
            setViewport(null);
            return;
        }
        const scrollInstance = HtmlScroll.addScroll(ref.current, axis, events);
        setViewport((_a = scrollInstance === null || scrollInstance === void 0 ? void 0 : scrollInstance.elements().viewport) !== null && _a !== void 0 ? _a : null);
        return () => {
            scrollInstance === null || scrollInstance === void 0 ? void 0 : scrollInstance.destroy();
            setViewport(null);
        };
    }, [isActive, ref, axis, events]);
    return viewport;
}
